import { Goal, Star, Ticket, Trophy } from "lucide-react";

// Renders a shared context attachment inside a chat bubble / composer preview.
export default function ChatContextCard({ context, mine, navigate, compact }) {
  if (!context || !context.type) return null;
  const base = `rounded-xl overflow-hidden mb-1.5 ${mine ? "bg-white/15" : "bg-background/70"} ${compact ? "" : "border border-border/50"}`;
  const go = (path) => path && navigate && navigate(path);

  if (context.type === "fixture") {
    return (
      <button data-testid="context-fixture" onClick={() => go(`/tournaments/${encodeURIComponent(context.tournament || context.league || "")}`)}
        className={`${base} w-full text-left p-2.5 hover:opacity-90 transition-opacity`}>
        <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-wide opacity-70 mb-1">
          <Goal className="h-3 w-3" /> Match {context.date ? `· ${new Date(context.date).toLocaleDateString()}` : ""}
        </div>
        <div className="font-display font-bold text-sm leading-tight">{context.home} vs {context.away}</div>
        {context.pred && (
          <div className="text-[11px] opacity-80 mt-0.5">
            {context.home} {context.pred.home}% · Draw {context.pred.draw}% · {context.away} {context.pred.away}%
            {context.pred.likely_score ? ` · likely ${context.pred.likely_score}` : ""}
          </div>
        )}
        {context.league && <div className="text-[10px] opacity-60 mt-0.5">{context.league}</div>}
      </button>
    );
  }
  if (context.type === "pick") {
    return (
      <button data-testid="context-pick" onClick={() => go(`/tournaments/${encodeURIComponent(context.tournament || "")}`)}
        className={`${base} w-full text-left p-2.5 hover:opacity-90 transition-opacity`}>
        <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-wide opacity-70 mb-1">
          <Star className="h-3 w-3" /> Pick
        </div>
        <div className="font-display font-bold text-sm leading-tight">{context.player}</div>
        <div className="text-[11px] opacity-85">{context.prop}
          {context.pct != null ? ` · ${context.pct}% chance` : ""}
          {context.odd != null ? ` · @${Number(context.odd).toFixed(2)}` : ""}
        </div>
        {context.matchup && <div className="text-[10px] opacity-60 mt-0.5">{context.matchup}</div>}
      </button>
    );
  }
  if (context.type === "bet") {
    const win = context.result === "win";
    const loss = context.result === "loss";
    return (
      <div data-testid="context-bet" className={`${base} p-2.5`}>
        <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-wide opacity-70 mb-1">
          <Ticket className="h-3 w-3" /> My bet
        </div>
        <div className="font-display font-bold text-sm leading-tight">{context.selection || context.market}</div>
        <div className="text-[11px] opacity-85">
          {context.market}{context.odds ? ` · @${Number(context.odds).toFixed(2)}` : ""}
          {context.stake ? ` · A$${Number(context.stake).toFixed(2)}` : ""}
        </div>
        {context.teams && <div className="text-[10px] opacity-60 mt-0.5">{context.teams}</div>}
        {context.result && context.result !== "pending" && (
          <span className={`text-[10px] font-bold ${win ? "text-[#34C759]" : loss ? "text-[#FF375F]" : "opacity-70"}`}>
            {win ? "Won" : loss ? "Lost" : context.result}
          </span>
        )}
      </div>
    );
  }
  if (context.type === "competition") {
    return (
      <button data-testid="context-competition" onClick={() => go(`/tournaments/${encodeURIComponent(context.name || "")}`)}
        className={`${base} w-full text-left p-2.5 hover:opacity-90 transition-opacity flex items-center gap-2`}>
        {context.logo ? <img src={context.logo} alt="" className="h-6 w-6 object-contain" /> : <Trophy className="h-5 w-5 opacity-70" />}
        <div>
          <div className="text-[10px] uppercase tracking-wide opacity-70">Competition</div>
          <div className="font-display font-bold text-sm leading-tight">{context.name}</div>
        </div>
      </button>
    );
  }
  return null;
}
